import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import Utilities from '../../pages/PayBills/Utilities';
import React, { useState } from 'react';
import constant from '../../utils/constant';

function UtilitiesContainer({ closeModal, setShowSurvey }) {
	const [selectElectricBill, setSelectElectricBill] = useState(false);
	const [mainContents, setMainContents] = useState(true);
	const [pinContent, setPinContent] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.PAYBILLSBUYELECTRICITY);

	const payElectricBill = () => {
		setSelectElectricBill(true);
		setPinContent(false);
		setMainContents(false);
	};

	const goBack = () => {
		if (selectElectricBill) {
			setSelectElectricBill(false);
			setMainContents(true);
		} else if (pinContent) {
			setPinContent(false);
			setSelectElectricBill(true);
		} else {
			closeModal();
		}
	};

	return (
		<Utilities
			closeModal={closeModal}
			selectElectricBill={selectElectricBill}
			mainContents={mainContents}
			payElectricBill={payElectricBill}
			goBack={goBack}
			pinContent={pinContent}
			setPinContent={setPinContent}
			needFeedback={needFeedback}
			setShowSurvey={setShowSurvey}
		/>
	);
}

export default UtilitiesContainer;
